import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	margin-top: -14px;
	opacity: ${props => props.opacity};
	max-height: ${props => props.height};
	transition: all 0.2s ease-out;
`;

const Bar = styled.div`
	background-color: ${props => props.color ? props.color : 'rgb(235, 235, 235)'};
	border-radius: 3px;
	height: 6px;
	width: 20%;
	margin-right: 2px;
	transition: background-color 0.3s ease-out;
`;

const Label = styled.div`
	font-size: 12px;
	color: rgb(180, 180, 180);
	margin-left: 8px;
`;

const PasswordIndicator = ({ t, strength }) => {
	let label = 'login/password indicator 0';

	if (strength > 0) {
		label = 'login/password indicator 1'
	}
	if (strength > 50) {
		label = 'login/password indicator 2'
	}
	if (strength > 100) {
		label = 'login/password indicator 3'
	}

	return (
		<Container
			opacity={strength > 0 ? '1' : '0'}
			height={strength > 0 ? '12px' : '0px'}
		>
			<Bar color={strength > 0 ? '#FE8383' : 'rgb(235, 235, 235)'} />
			<Bar color={strength > 50 ? '#F9C77B' : 'rgb(235, 235, 235)'} />
			<Bar color={strength > 100 ? '#71C6A4' : 'rgb(235, 235, 235)'} />
			<Label>
				{t(label)}
			</Label>
		</Container>
	)
}

PasswordIndicator.propTypes = {
	strength: PropTypes.number,
	t: PropTypes.func,
}

export default PasswordIndicator
